import { Collaboration } from "@back4app2/sdk";
import Modal from "../Modal";
import Button from "../Button";
import { ReactComponent as TriangleExclamationIcon } from '../../assets/images/triangle-exclamation.svg';

export interface RemoveCollaboratorModalProps {
  open: boolean;
  collaborator: Collaboration | null;
  isRemoving: boolean;
  error: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveCollaboratorModal = ({
  open,
  collaborator,
  isRemoving,
  error,
  onClose,
  onConfirm,
}: RemoveCollaboratorModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <>
        <div className="flex w-full justify-center">
          <TriangleExclamationIcon className="text-error-red" width="40px" height="56px" />
        </div>
        <div className="leading-140 flex flex-col justify-center text-dark text-center mb-2">
          Are you sure you want to remove{' '}
          <span className="font-medium">{collaborator?.email}</span>
          {' '}as a collaborator?
        </div>
        {error && (
          <div className="text-xs text-error-red text-center mt-2 mb-2">{error}</div>
        )}
        <div className="flex justify-center space-x-2 w-full mt-4">
          <Button
            className="text-dark-grey border border-light-grey text-xs px-[0.625rem] py-2 font-semibold rounded-[5px]"
            onClick={onClose}
            isDisabled={isRemoving}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="bg-error-red text-xs px-[0.625rem] py-2 font-semibold rounded-[5px] text-white"
            onClick={onConfirm}
            isDisabled={isRemoving}
          >
            {isRemoving ? 'Removing...' : 'Remove'}
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default RemoveCollaboratorModal;

